module.exports = __webpack_public_path__ + "img/suoluetu.c4b4ca3a.png";